import Vue from "vue";
import { isEmpty } from "lodash";
export default Vue.extend({
  data() {
    return {
      required: (v) => {
        if (Array.isArray(v)) {
          return !isEmpty(v) || "Required field";
        }
        return !!v || v === 0 || !isEmpty(v) || "Required field";
      },
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+/.test(v) || "Email is not valid",
        (v) => !/\s/.test(v) || "Email must not contain spaces",
        (v) => v?.indexOf("@") === v?.lastIndexOf("@") || "Email is not valid",
        (v) => /^[^@]+@[^@]+$/.test(v) || "Email is not valid",
        (v) => /@.+\..+/.test(v) || "Email is not valid",
        (v) => !/[!#$%^&*()=[\]{};:"\\|,<>/?]+/.test(v) || "Email is not valid",
      ],
    };
  },
});
